import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
    selector: 'app-medecin-direct',
    templateUrl: './medecin-direct.component.html',
    styleUrls: ['./medecin-direct.component.scss']
})
export class MedecinDirectComponent implements OnInit {

  constructor(private configurationService: ConfigurationService) { }
  showMedecinDirect =false
  ngOnInit(): void {
      this.showMedecinDirect = this.configurationService.get().medecinDirect.show;
  }

}
